/**
 * Lead Generation Page
 * Standalone page for AI-powered lead generation
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import LeadGenerationTab from './LeadGenerationTab';
import { useIsMobile } from '../../../utils/responsiveUtils';

const LeadGenerationPage: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <Container maxWidth="xl" sx={{ py: isMobile ? 2 : 4, px: isMobile ? 1 : 3 }}>
      <Box mb={isMobile ? 2 : 4}>
        <Typography variant={isMobile ? 'h5' : 'h4'} fontWeight="bold" gutterBottom>
          Lead Generation
        </Typography>
        <Typography variant={isMobile ? 'body2' : 'body1'} color="text.secondary">
          AI-powered lead generation and prospecting
        </Typography>
      </Box>
      <LeadGenerationTab />
    </Container>
  );
};

export default LeadGenerationPage;
